module.exports = __webpack_public_path__ + "assets/img/status-overdue.a76bb33b.svg";